import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "toolkit/hooks";

interface RequireAuthProps {
	children: ReactNode;
}

const RequireAuth: FC<RequireAuthProps> = ({ children }): any => {
	let location = useLocation();

	const token = useAppSelector((state) => state.profile.profile.token);

	return token ? children : <Navigate to="login" state={{ from: location }} replace />;
};

export default RequireAuth;
